import Vue from 'vue';

import CultureAwareRouterLink from '@/core/dom/culture-aware-router-link.vue';
import Breakpoints from '@/core/responsive/breakpoints/Breakpoints.vue';
import ResponsiveImage from '@/core/responsive/image/ResponsiveImage.vue';

Vue.component('Breakpoints', Breakpoints);
Vue.component('CultureAwareRouterLink', CultureAwareRouterLink);
Vue.component('ResponsiveImage', ResponsiveImage);
